import { Routes, Route } from "react-router-dom"
// import { Routes, Route } from ".@router" // TODO: to hide this framework on wappalyzer detection
import Home from "./pages/home/Home"
import OurStory from "./pages/our-story/OurStory"
import Wwb from "./pages/our-story/sub-pages/WWB"
import OurOhana from "./pages/our-story/sub-pages/OurOhana"
import RachmanAndSons from "./pages/our-story/sub-pages/RachmanAndSons"
import TheLoroBlonyo from "./pages/our-story/sub-pages/TheLoroBlonyo"
import DiSini from "./pages/di-sini/DiSini"
import NavigationProvider from "./global/GlobalContext"
import DiSana from "./pages/di-sana/DiSana"
import ComingSoon from "./pages/ComingSoon"
import DSCategory from "./pages/di-sana/sub-pages/category/Category"
import Product from "./pages/di-sana/sub-pages/category/product/Product"
import DiSanaFAQ from "./pages/di-sana/sub-pages/FAQ"
import ReturnP from "./pages/di-sana/sub-pages/ReturnP"
import ShippingP from "./pages/di-sana/sub-pages/ShippingP"
import Cart from "./pages/di-sana/sub-pages/Cart"
import CulturalEvent from "./pages/cultural-event/CulturalEvent"
import Gallery from "./pages/gallery/Gallery"
import Philanthropy from "./pages/Philanthropy"
import Press from "./pages/press/Press"
import SpecialEvent from "./pages/di-sini/sub-pages/SpecialEvent"
import Reservation from "./pages/di-sini/sub-pages/Reservation"
import Auth from "./pages/Auth"
import NotFoundPage from "./pages/NotFoundPage"
import Payment from "./pages/di-sana/sub-pages/Payment"
import Purchase from "./pages/user-dashboard/Purchase"
import Menu from "./pages/di-sini/sub-pages/Menu"
import Profile from "./pages/user-dashboard/Profile"
import { AccessResetPass, AuthRoute, RedirectToContactUs, UnAuthRoute, UnRegis, UnReleased } from "./components/route-handler/PrivateRoute"
import CulturalEventDetail from "./pages/cultural-event/sub-pages/Detail"
import CacheBuster from 'react-cache-buster';
import { version } from "../package.json"
import TourGuide from "./pages/tour-guide/TourGuide"
import TourGuideDetail from "./pages/tour-guide/sub-pages/Detail"
import Loader from "./components/Loader"
import "./App.css"
import "./assets/css/option-logo-layout.css"
import "./assets/css/navbar-component.css"
import Blog from "./pages/blog/Blog"
import BlogDetail from "./pages/blog/sub-pages/Detail"
import PorcelainCatalog from "./pages/di-sana/sub-pages/porcelain-catalog/PorcelainCatalog"
import Announcements from "./pages/Announcements"
const App = () => {
  const isProduction = process.env.NODE_ENV === "production";
  const metaDir = import.meta.env.BASE_URL.replace(/\/$/, "");

  return (
    <>
      <NavigationProvider>
        <CacheBuster
          currentVersion={version}
          isEnabled={isProduction}
          reloadOnDowngrade={true}
          metaFileDirectory={metaDir === "/" ? "" : metaDir}
          isVerboseMode={false}
          loadingComponent={<Loading />}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/press" element={<Press />} />
            <Route path="/philanthropy" element={<Philanthropy />} />
            {/* OUR STORY */}
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/our-story/what-we-believe" element={<Wwb />} />
            <Route path="/our-story/our-ohana" element={<OurOhana />} />
            <Route path="/our-story/rachman-and-sons" element={<RachmanAndSons />} />
            <Route path="/our-story/the-loro-blonyo" element={<TheLoroBlonyo />} />
            {/* STORE */}
            <Route path="/di-sana" element={<DiSana />} />
            <Route path="/di-sana/:slug" element={<DSCategory />} />
            <Route path="/di-sana/:category/:slug" element={<Product />} />
            {/* <Route path="/di-sana/faq" element={<DiSanaFAQ />} /> */}
            <Route path="/di-sana/faq" element={<UnReleased />} />
            <Route path="/di-sana/shipping-policy" element={<ShippingP />} />
            <Route path="/di-sana/return-policy" element={<ReturnP />} />
            {/* <Route path="/di-sana/announcements" element={<Announcements />} /> */}
            {/* <Route path="/cart" element={<AuthRoute Component={Cart} />} />
            <Route path="/cart/checkout" element={<Payment />} /> */}
            <Route path="/cart" element={<UnReleased />} />
            <Route path="/cart/checkout" element={<UnReleased />} />
            {/* PORCELAIN CATALOG */}
            <Route path="/di-sana/loro-blonyo-fine-porcelain" element={<PorcelainCatalog />} />
            {/* CULTURAL EVENTS */}
            <Route path="/cultural-events" element={<CulturalEvent />} />
            <Route path="/cultural-events/:slug" element={<CulturalEventDetail />} />
            {/* RESTAURANT */}
            <Route path="/di-sini" element={<DiSini />} />
            <Route path="/di-sini/special-events" element={<SpecialEvent />} />
            <Route path="/di-sini/reservation" element={<Reservation />} />
            {/* MENUS */}
            <Route path="/di-sini/menus" element={<Menu />} />
            <Route path="/di-sini/menus/:slug" element={<Menu />} />
            {/* AUTH */}
            {/* <Route path="/auth/login" element={<UnAuthRoute Component={Auth} />} />
            <Route path="/auth/registration" element={<UnAuthRoute Component={Auth} />} />
            <Route path="/auth/forgot-password" element={<UnAuthRoute Component={Auth} />} />
            <Route path="/reset-password" element={<AccessResetPass Component={Auth} />} />
            <Route path="/auth/verification" element={<UnRegis Component={Auth} />} /> */}
            <Route path="/auth/login" element={<UnReleased />} />
            <Route path="/auth/registration" element={<UnReleased />} />
            <Route path="/auth/forgot-password" element={<UnReleased />} />
            <Route path="/reset-password" element={<UnReleased />} />
            <Route path="/auth/verification" element={<UnReleased />} />
            {/* USER DASHBOARD */}
            {/* <Route path="/user/dashboard/my-purchase/" element={<AuthRoute Component={Purchase} />} />
            <Route path="/user/dashboard/profile" element={<AuthRoute Component={Profile} />} />
            <Route path="/user/dashboard/change-password" element={<AuthRoute Component={Auth} />} /> */}
            <Route path="/user/dashboard/my-purchase" element={<UnReleased />} />
            <Route path="/user/dashboard/profile" element={<UnReleased />} />
            <Route path="/user/dashboard/change-password" element={<UnReleased />} />
            {/* TOUR GUIDE */}
            {/* <Route path="tour-guides/" element={<TourGuide />} />
            <Route path="tour-guides/:slug" element={<TourGuideDetail />} /> */}
            {/* BLOG */}
            <Route path="blogs/" element={<Blog />} />
            <Route path="blogs/:slug" element={<BlogDetail />} />
            {/* OTHERS */}
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </CacheBuster>
      </NavigationProvider>
    </>
  )
}

const Loading = () => {
  return (
    <div id="bg" className="fixed z-50 bg-[#6c5f58] h-screen w-full flex justify-center items-center">
      <Loader />
    </div>
  )
}

export default App
